import React from "react";
import {
  Dialog,
  DialogContent,
  makeStyles,
  IconButton,
  Tooltip,
  Button,
  Grid,
  Typography,
  DialogTitle,
  Divider,
  DialogActions,
  ButtonGroup,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import DeleteIcon from "@material-ui/icons/Delete";
import { useDispatch, useSelector } from "react-redux";
import { deleteGasBottleSign } from "../../../actions/inventoryAction";
import Feedback from "../../../utils/Feedback";

const useStyles = makeStyles((theme) => ({
  dialogContent: {
    padding: theme.spacing(4),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(2),
    },
  },
  title: {
    fontSize: 13,
  },
  typo: {
    lineHeight: 1,
    textTransform: "uppercase",
    fontWeight: 600,
  },
}));

const DeleteCompressedGasBottleModal = ({ openDelete, handleCloseDelete, id, onDeleted }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [feed, setFeed] = React.useState({
    loading: false,
    open: false,
    message: "",
    success: false,
  });

  const { loading, error } = useSelector((state) => state.inventory);

  React.useEffect(() => {
    const abortController = new AbortController();
    if (error && error !== null) {
      setFeed((prev) => ({
        ...prev,
        loading: false,
        open: true,
        message: error,
        success: false,
      }));
    }
    return () => {
      abortController.abort();
    };
  }, [error]);

  const handleDeleteHandler = async () => {
    try {
      await dispatch(deleteGasBottleSign(id));
      handleCloseDelete();
      if (onDeleted) {
        onDeleted();
      }
      setFeed((prev) => ({
        ...prev,
        loading: false,
        open: true,
        message: "Compressed gas bottle record deleted successfully.",
        success: true,
      }));
    } catch (err) {
      setFeed((prev) => ({
        ...prev,
        loading: false,
        open: true,
        message: err.message || "Failed to delete compressed gas bottle record.",
        success: false,
      }));
    }
  };

  const handleCloseFeed = () => {
    setFeed((prevState) => ({ ...prevState, open: false }));
  };

  return (
    <div>
      <Feedback
        handleCloseFeed={handleCloseFeed}
        open={feed.open}
        severity={feed.success ? "success" : "error"}
        message={feed.message}
      />
      <Dialog
        open={openDelete}
        onClose={handleCloseDelete}
        aria-labelledby="form-dialog-title"
        maxWidth="md"
      >
        <DialogTitle>
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item>
              <Typography variant="overline" className={classes.title}>
                Delete Compressed Gas Record
              </Typography>
            </Grid>
            <Grid item>
              <Tooltip arrow title="Close">
                <IconButton onClick={handleCloseDelete} size="large">
                  <CloseIcon />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </DialogTitle>
        <Divider />
        <DialogContent className={classes.dialogContent}>
          <Typography variant="body2" className={classes.typo} color="secondary">
            Are You Sure You Want To Delete This Compressed Gas Bottle Record?
          </Typography>
        </DialogContent>
        <DialogActions>
          <ButtonGroup variant="contained">
            <Button color="default" onClick={handleCloseDelete}>
              Cancel
            </Button>
            <Button
              color="secondary"
              onClick={handleDeleteHandler}
              endIcon={<DeleteIcon />}
              disabled={loading}
            >
              {loading ? "Loading..." : "Delete"}
            </Button>
          </ButtonGroup>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DeleteCompressedGasBottleModal;